import { render, staticRenderFns } from "./PopupMsg.vue?vue&type=template&id=49321931"
import script from "./PopupMsg.vue?vue&type=script&lang=js"
export * from "./PopupMsg.vue?vue&type=script&lang=js"
import style0 from "./PopupMsg.vue?vue&type=style&index=0&id=49321931&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports